
import Heading from "./Heading.tsx";

type VideoLinkType = {

  background?: string,
  bg?: string,
  color?: string
}

export default function ScoreKey({background,bg,color}:VideoLinkType) {


    return (
      <div>
        <Heading
          label="Thang điểm đánh giá"
          background={background || "black"}
        />
        
        <Scores bg={bg} color={color} />
        
      
      </div>
    );
}


function Scores({ bg, color }: VideoLinkType) {
  return (
    <div className="flex">
      {gradingScale.map((g,i) => (
        <div
          className="flex-1 text-center"
          style={{ borderLeft: "black 1px solid", color, background: bg, borderRight: i===gradingScale.length-1 ? "black 1px solid" : "none" }}
        >
          <div
            style={{ borderBottom: "black 1px solid" }}
            className="p-2"
          >{`${g.code} - ${g.english}`}</div>
          <div
            style={{ borderBottom: "black 1px solid" }}
            className="p-2"
          >
            {g.vietnamese}
          </div>
          <div
            style={{ borderBottom: "black 1px solid" }}
            className="p-2"
          >
            {g.scoreRange}
          </div>
        </div>
      ))}
    </div>
  );
}

const gradingScale = [
  {
    code: "P",
    english: "Poor",
    vietnamese: "Chưa đạt",
    scoreRange: "< 5.9"
  },
  {
    code: "F",
    english: "Fair",
    vietnamese: "Cần cải thiện",
    scoreRange: "6.0–6.9"
  },
  {
    code: "G",
    english: "Good",
    vietnamese: "Khá",
    scoreRange: "7.0–7.9"
  },
  {
    code: "VG",
    english: "Very Good",
    vietnamese: "Giỏi",
    scoreRange: "8.0–8.9"
  },
  {
    code: "E",
    english: "Excellent",
    vietnamese: "Xuất sắc",
    scoreRange: "9.0–10"
  }
];

  
